import { Role } from "./role";

export interface ResponseData {
    token_type: string;
    expires_in?: number;
    access_token?: string;
    refresh_token?: string;
    userDetails?: UserDetailsResponse;
}
export interface UserDetailsResponse {
    userId: number;
    userName: string;
    firstName: string;
    middleName: string;
    lastnName: string | null;
    licenseId: number | null;
    userRole: string | null;
    modifiedBy: number;
    clientId: number;
    createdOn: string;
    modifiedOn: string;
    createdBy: number;
    userType: number;
    isActive: number;
    password: string;
}
export interface ApiResponse {
    message: string;
    code: string;
    data: any;
    status: boolean | string | number;
    error_code?: number;
}

export interface TransactionListByClient {
    requestBatchId: number | null;
    documentID: number | null;
    eHealthId: number | null;
    memberId: number | null;
    payerId: string | null;
    prescriptionId: number | null;
    providerId: number | null;
    receiverId: string | null;
    senderId: string | null;
    transactionDate?: string;
    visitedOn?: string;
    requestId: number;
    dispensedStatus: number | null;
    approvalStatus: number | null;
    faciltyId: string | null;
}

export interface PayerDetails {
    client_id?: number;
    client_secret?: string | null;
    clientValidityStart?: string | null;
    clientValidityEnd?: string | null;
    contactPerson: ContactPerson[];
    country: number;
    addCountry: number;
    assocCountry: number;
    credentials: Credentials[];
    currency: number | null;
    payerId: number | null;
    payerName: string | null;
    payerCode: string | null | number;
    payerType: string | null;
    tpaPayers: [];
    region: number;
    area: string;
    areaCode: any;
    areaName: any;
    geocode: any;
    buildingName: any;
    streetName: any;
    url: string | null;
    validityEnd: any;
    validityStart: any;
    website: string | null;
    description: string | null;
    payerCapIntegration : {
        typeOfApi: string,
        endpoint: string,
        typeOfAuthorization: string,
        clientId: string,
        clinetSecret: string,
        redirectUri: string,
        token: string,
        method: string,
        requestPayloadSchema: string,
        activeToEnd: string,
    }[]
}
export interface ProviderDetails {
    providerId: number;
    regulatorId: number;
    licenseId: string;
    regStart: string;
    regEnd: string;
    providerName: string;
    groupId: string;
    providerType: number;
    facilityType: number | null;
    country: number;
    region: number;
    area: any;
    areaCode: any;
    areaName: any;
    geoCode: any;
    buildingName: string | null;
    streetName: string | null;
    validityStart: any;
    facilityId: string;
    validityEnd: any;
    billingCurrency: number;
    client_id: number;
    client_secret: string;
    clientValidityStart: string;
    clientValidityEnd: string;
    clientUrl: string;
    serviceCodeType: number[];
    contactPerson: ContactPerson[];
    providerCode: string | null;
    provider_type: ProviderTypeList[]
    speciality: SpecialityTypeList[]
}

export interface Credentials {
    country: number;
    createdBy: number | null;
    createdOn: string | null;
    isActive: number | null;
    modifiedBy: number | null;
    modifiedOn: string | null;
    payerCredentialId: number | null;
    payerId: number | null;
    receiverId: string | null;
    payerRegReferenceId: string;
    payerRegulatorId: string | null;
    regulatorId: number | null;
    url: string | null;
    username: string | null;
}
export interface ContactPerson {
    clientId?: number;
    contactEmail?: string;
    contactPersonFname?: string;
    contactPersonId?: number;
    contactPersonLname?: string;
    contactPersonMname?: string;
    contactPhone?: number;
    createdBy?: number;
    createdOn?: string;
    isActivr?: number;
    modifiedBy?: number;
    modifiedOn?: string;
    pivot?: { payerId: number; contactPersonId: number };
    position?: string | null;
    roles: Role[];
    userId?: number;
    countryPhoneCode: any[];
    password: any;
    username: any;
}

export interface Currency {
    clientId: number;
    createdBy: number;
    createdOn: string | null;
    currencyCode: string | null;
    currencyDesc: string | null;
    currencyId: number;
    isActive: number;
    modifiedBy: number;
    modifiedOn: string;
    symbol: string;
    validFrom: string | null;
    validTo: string | null;
}

export interface Country {
    countryCode: string | null;
    countryId: number;
    countryName: string;
}

export interface State {
    regionId: number;
    regionName: string | null;
}

export interface Regulator {
    country: number;
    regulatoryAuthority: string;
    regulatoryAuthorityCode: string | null;
    regulatoryId: number;
}
export interface HeaderInfo {
    dispositionFlag: boolean;
    payerId: number;
    receiverId: string | null;
    recordCount: string | null;
    requestBatchId: number;
    requestId: number;
    senderId: string;
    transactionDate: string | null;
    providerId: number;
    providerCode: string;
    payerCode: string;
    providerTypeCode : string;
}
export interface Prescription {
    activity: Activity[];
    clinician: string | null;
    comments: string | null;
    diagnosis: Diagnosis[];
    referenceNumber: string | null;
    type: string | null;
    id: number;
    encounter: Encounter;
    patient: Patient;
}
export interface Diagnosis {
    diaganosisVersion: string | null;
    diaganosisCode: number | null;
    diaganosisClassification: string | null;
}
export interface Activity {
    activityType: number;
    indication: number | null;
    drugCode: string | null;
    quantity: number | null;
    duration: number | null;
    unitId: number | null;
    singleDoseID: number | null;
    hasRefill: number | null;
    PRN: number | null;
    instructions: null;
    arabicInstructions: null;
    routeOfAdmin: string | null;
    activityStartDate: string | null;
    instructionType: null;
    isFlexed: number | null;
    prescriptionActivityId: number | null;
    frequencies: Frequencies[];
    observation: Observation[];
    drugName?: string | null;
}
export interface Observation {
    observationCode: string | null;
    observationType: string | null;
    observationValue: string | null;
    observationValueType: string | null;
}
export interface Frequencies {
    unitPerFrequency: number | null;
    frequencyValue: number | null;
    frequencyType: string | null;
    dosageAsNeeded: string | null;
    freqQuantity: number | null;
    freqDuration: number | null;
    repeatPattern: number | null;
    frequencyPrecondition: number | null;
}
export interface Patient {
    bloodGroup: string | null;
    dob: string | null;
    dobHijri: string | null;
    expectedDob: string | null;
    eHealthId: string | null;
    email: string | null;
    gender: string | null;
    idType: string | null;
    memberFirstName: string | null;
    memberId: string | null;
    memberLastName: string | null;
    memberMiddleName: string | null;
    nationalId: string | null;
    nationality: string | null;
    phone: string | null;
    preferredLanguage: string | null;
    emiratesIDNumber: string | null;
    net: string | null;
    patientShare: string | null;
    gross: string | null;
    claimId: string | null;
    memberCode: string | null;

}
export interface Encounter {
    allergyCodes: AllergyCodes[] | null;
    idType: string | null;
    name: string | null;
    vitalSigns: VitalSigns[] | null;
    patientObservation: PatientObservation;
    visit: Visit;
    facility_id: string;
    facility_name: string;
    startOn: string;
    startType: string;
    endOn: string;
    endtype: string;
}
export interface AllergyCodes {
    allergyCode: number | null;
    severity: number | null;
    allergyType: number | null;
}
export interface VitalSigns {
    vitalSignType: string | null;
    vitalSignsValueType: string | null;
    vitalSignsValue: number | null;
    systolic: string | null;
    diastolic: string | null;
}
export interface PatientObservation {
    age: string | null;
    headSize: string | null;
    height: string | null;
    lactating: string | null;
    maritalStatus: string | null;
    occupation: string | null;
    patientStatus: string | null;
    pregnancyStatus: string | null;
    weight: string | null;
}
export interface Visit {
    visitId: string | null;
    visitedOn: string | null;
}

export interface ProviderDetails {
    billingCurrency: number;
    client_id: number;
    client_secret: string;
    contactPerson: ContactPerson[];
    groupId: string;
    licenseId: string;
    providerId: number;
    providerName: string;
    providerType: number;
    regEnd: string;
    regStart: string;
    regulatorId: number;
    serviceCodeType: number[];
    validityEnd: any;
    validityStart: any;
}

export interface City {
    locationId: number;
    locationName: string | null;
    codes: PostalCode;
}
export interface PostalCode {
    postalCode: number;
    geoCode: string | null;
}

export interface DrugList {
    drugCodeDesc: string | null;
    drugCodeName: string | null;
    mappedPlanId: number;
    payerPreferredCode: string | null;
    payerPlanName: string | null;
    payerPlanCode: string | null;
    drugCodeVersion: string | null;
    activeFrom: string | null;
    expiredOn: string | null;
    payerPreferredDrugId: number | string | null;
    payerName: string | null;
    payerPlanId: number | string | null;
    linkedPayerProvider: number | string | null;
    drugListCode: number | string | null;
    isActive: number | null;
    payerId: number | null;

}
export interface MasterDrugList {
    drugVersionId: number | null;
    drugVersion: string | null;
    description: string | null;
    activeFrom: string | null;
    expiredOn: string | null;
}
export interface DrugDetails {
    drugDoseId: number;
    drugName: string | null; //
    drugCode: string | null; //
    _expanded: boolean;
    availability: Availability[]; //

    payerName?: string;
    payerPreferredCode?: string;
    drugCodeVersion?: string;
    activeFrom?: string;
    expiredOn?: string;
    drugVersion?: string;

}
export interface Availability {
    doseStrength: string | null;
    doseUnit: string | null;
    drugInForm: string | null;
    manufacturers: Manufactures;
}
export interface Manufactures {
    brandName: string | null;
    tradeName: string | null;
    package: Package;
    drugIdentifier: string | null;
    allowedMaxDuration: string | null;
    allowedMaxDailyDose: string | null;
    allowedSpecialInstruction: number;
    maxNoRefill: string | null;
    maxUnitAllowed: string | null;
    maxAllowedBox: string | null;
    providerType: string;
    speciality: string;
    isControlled: string;
}
export interface Package {
    packageType: string | null;
    price: number;
    packageSize: number;
}
export interface PrefferedList {
    payerPreferredDrugId: number | string | null;
    payerName: string | null;
    payerPlanCode: string | number | null;
    payerPlanId: number | string | null;
    payerPreferredCode: string | null;
    linkedPayerProvider: number | string | null;
    drugListCode: number | string | null;
    drugCodeVersion: string | null;
    activeFrom: string | null;
    expiredOn: string | null;
    drugCodeDesc: string | null;
    payerPlanName: string | null;
    isActive: number | null;
    payerId: number | null;
    mappedPlanId?: number | null
}

export interface RuleManagement {
    ruleMasterId: number;
    clientId: number;
    rule: string;
    typeOfRule: string;
    serviceClass: string;
    createdOn: string;
    createdBy: number;
    modifiedOn: string;
    modifiedBy: number;
    sortOrder: number;
    isActive: number;
}

export interface PermissionsApi {
    id: number;
    name: string;
    guard_name: string;
    created_at: Date;
    updated_at: Date;
    displayName: string;
    permissions: string[];
}

export interface ProviderTypeList {
    providerTypeId: number,
    clientId: number,
    providerType: string,
    providerTypeCode: string,
    isActive: number | null
}
export interface SpecialityTypeList {
    specialityId: number;
    speciality: string;
    specialityCode: string;
    clientId: number;
    createdOn: string;
    modifiedOn: string | null;
    createdBy: string | null;
    modifiedBy: string | null;
    isActive: string | null;
}

